export default __webpack_public_path__ + "static/media/polygon.2415b77d.png";